import { render } from "./SpotFooter.vue?vue&type=template&id=628bfe15&scoped=true"
import script from "./SpotFooter.vue?vue&type=script&lang=js"
export * from "./SpotFooter.vue?vue&type=script&lang=js"

import "./SpotFooter.vue?vue&type=style&index=0&id=628bfe15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628bfe15"]])

export default __exports__